import React from 'react';

export const TextMarker = props => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(props.style || {})
      }}>
      <div
        style={{
          backgroundColor: props.color || 'red',
          borderRadius: 16,
          paddingLeft: 10,
          paddingRight: 10
        }}>
        <p
          variant="subtitle2"
          style={{
            color: 'white',
            // textShadow: '-1px -1px 2px black',
            ...(props.textStyle || {})
          }}>
          {props.children}
        </p>
      </div>
    </div>
  );
};
